import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0c159821"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "prize-valid-form-item"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("长期有效");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("30天有效");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("60天有效");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("90天有效");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("自定义截止日期");

import { computed } from 'vue';
export default {
  name: 'PrizeValidFormItem',
  props: {
    validType: {
      type: Number,
      default: 1
    },
    validEndDate: {
      type: String,
      default: ''
    }
  },
  emits: ['update:validType', 'update:validEndDate'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const innerValidType = computed({
      get() {
        return props.validType;
      },

      set(val) {
        emit('update:validType', val);
      }

    });
    const innerValidEndDate = computed({
      get() {
        return props.validEndDate;
      },

      set(val) {
        emit('update:validEndDate', val || '');
      }

    });
    /** 禁用当前日期之前的日期（当天可选） */

    function disabledDate(date) {
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
    }

    function handleTypeChange(val) {
      if (val !== 5) {
        emit('update:validEndDate', '');
      }

      emitChange();
    }

    function emitChange() {// parent form can validate via watchers if needed
    }

    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(innerValidType),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(innerValidType) ? innerValidType.value = $event : null),
        class: "valid-radio-group",
        onChange: handleTypeChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 2
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 3
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 4
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 5
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _unref(innerValidType) === 5 ? (_openBlock(), _createBlock(_component_el_date_picker, {
        key: 0,
        modelValue: _unref(innerValidEndDate),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(innerValidEndDate) ? innerValidEndDate.value = $event : null),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "请选择截止日期",
        style: {
          "width": "220px",
          "margin-top": "8px"
        },
        "disabled-date": disabledDate,
        onChange: emitChange
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }

};